<template>
  <div id="samba-player"></div>
</template>

<script>
import VideosAPI from '@/api/videos-api'

export default {
  name: 'SambatechPlayer',
  props: {
    ementaId: Number,
    tipoOrigemId: Number,
    urlVideo: {
      type: String,
      required: true
    },
    inicio: Number
  },

  data () {
    return {
      tempoTotalVideo: 0,
      tempoAtualVideo: 0
    }
  },

  created () {
    let scriptSambaPlayerApi = document.createElement('script')
    scriptSambaPlayerApi.setAttribute('src', 'https://player.sambatech.com.br/v3/samba.player.api.js')
    scriptSambaPlayerApi.setAttribute('samba-player-api', 'player')
    document.head.appendChild(scriptSambaPlayerApi)
  },

  async mounted () {
    await new Promise(resolve => setTimeout(resolve, 1000))
    /* eslint-disable */
    var player = new SambaPlayer('samba-player', {
      ph: this.playerHash,
      m: this.mediaId,
      playerParams: {
        enableShare: true,
        autoStart: true,
        initialTime: parseInt(this.inicio)
      },
      events: {
        'onLoad': this.eventListener,
        'onStart': this.eventListener,
        'onFinish': this.eventListener,
        'onListen': this.eventListener,
        'onPause': this.eventListener
      }
    })

    this.intervalId = setInterval(() => {
        this.concluiVideo()
    }, 3000)
  },

  beforeDestroy(){
    clearInterval(this.intervalId);
  },

  computed: {
    playerHash: function () {
      let arrayUrl = this.urlVideo.split('/')
      return arrayUrl[arrayUrl.length - 2]
    },

    mediaId: function () {
      let arrayUrl = this.urlVideo.split('/')
      return arrayUrl[arrayUrl.length - 1]
    },

    autoplay: function () {
      return JSON.parse(localStorage.getItem('autoplay'))
    },

    controleTopico: function () {
      return this.$store.getters.getControleTopico
    }
  },

  methods: {
    eventListener (player) {
      if (player.event == 'onListen') {
        this.tempoTotalVideo = player.duration / 1000
        this.tempoAtualVideo = player.eventParam
      }
      if (player.event == 'onPause') {
        VideosAPI.atualizarTempoVideo(this.ementaId, this.tempoAtualVideo)
      }
    },

    autoplayVideo () {
      if (this.autoplay) {
        window.eventBus.$emit('salvarAnotacao')
        window.eventBus.$on('anotacaoSalva', async () => {
          await this.$store.dispatch('iniciaTimer', 5)
          this.$router.push(this.controleTopico.proximo.url)
        })
      }
    },

    concluiVideo() {
      this.$store.dispatch('concluiEmentaVideo', { ementaId: this.ementaId, tempoAtual: this.tempoAtualVideo, tempoTotal: this.tempoTotalVideo })
    }
  }
}
</script>

<style scoped>

</style>
